import { languageMapping, languagesInfo } from '@/constants';

export const getLocale = (): string => {
  const detectedLocale = navigator.language.split('-')[0] || 'en';

  const normalizedLocale = languageMapping[detectedLocale] || detectedLocale;

  const availableLocales = languagesInfo.map((lang) => lang.value);

  return availableLocales.find((locale) => normalizedLocale.toLowerCase().includes(locale)) || 'en';
};
